import { render } from "./new-full-img.vue?vue&type=template&id=0e3798e5&scoped=true&lang=html"
import script from "./new-full-img.vue?vue&type=script&lang=js"
export * from "./new-full-img.vue?vue&type=script&lang=js"

import "./new-full-img.vue?vue&type=style&index=0&id=0e3798e5&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e3798e5"]])

export default __exports__